import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MusicianProfileForm.html?raw';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import { MusicianProfileFormTypes as Types } from "./MusicianProfileFormTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import { InternalInstrumentsEditor } from "../MainCatalogsEditor/MainCatalogEditorTools";
import EntityStore from '../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';

class MusicianProfileForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    btnAddNewInstrument: HTMLElement;
    instrumentsTableContainer: HTMLElement;

    instrumentsTable: MdsLax<InstanceType<typeof StaticTable>>;
    instrumentStore: MdsLax<InstanceType<typeof EntityStore<Types.Instrument>>>;
    instrumentList: Array<Types.Instrument>;

    private userID: string;
    private user;


    private _tabelFormatter(cell: StaticTable.StaticTableCell<Types.Instrument>): boolean {
        let node = cell.tableCellNode;
        let entity = cell.entity;
        let tableRow = cell.tableRow;
        let name = cell.name;



        return false;
    }


    loadMusicianProfileData(entityID?: string): void {
        this.StandbyStart();
        if (!entityID) entityID = this.getCurrentUserId();

        let jsonData = {
            entityID: entityID,
            mode: "standard"
        };

        this.RequestManager.callfunction("Webtool_API_MusicianProfile__LoadData",
            jsonData,
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError));
    }
    private refreshData() {

        this.loadMusicianProfileData();
    }

    private _onLoadDataResponse(response: Types.MusicianProfileData) {
        //this.instrumentList = response.instrumentsData);

        this.userID = response.userData.ref_person.ID;
        this.user = response.userData.ref_person;

        this.instrumentStore.setup(response.instrumentsData);
        this._setUpTable(response.tableLayout.layouts[0])
        this.StandbyStop();


        this.emit("loaded", this._hasData());
    }
    private _setUpTable(layout: StaticTable.Layout) {

        if (this.instrumentsTable != null) this.instrumentsTable.destroy();

        this.instrumentsTable = new StaticTable();

        this.instrumentsTable.setupFromStore(this.instrumentStore);

        this.instrumentsTable.setRowClick(lang.hitch(this, this._onRowClick));
        this.instrumentsTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditButton));
        this.instrumentsTable.addDefaultRowActionButton("delete");
        this.instrumentsTable.setFormatter(this._tabelFormatter);

        this.instrumentsTable.on("tableDrawn", lang.hitch(this, this.removeDeleteButtons));
        this.instrumentsTable.setCyAttribute("MusicianProfileInstrumentsTable");

        this.instrumentsTable.setLayout(layout);
        this.instrumentsTable.placeAt(this.instrumentsTableContainer);

        //this.updateInstrumentsTable();
    }

    private _onStoreChange(): void {
        this.emit("changeStore", { hasData: this._hasData(), diffData: this.instrumentStore.getDiffData() });
    }

    private _hasData(): boolean {
        return this.instrumentStore.getCurrentCompleteList().length > 0;
    }

    private updateInstrumentsTable() {
        let instruments = this.instrumentList;

        this.instrumentsTable.setData(instruments);

    //    instruments?.forEach(i => {
    //        if (i.allowedToEdit === false) {
    //            this.disableNode(this.instrumentsTable.getRowGroupByKeyValue(i.ID, "ID").rows[0].node);
    //        }
    //    })
    }
    private _onLoadDataError(err: more.requestErrorMessage) {

        this.showToast(err.Message, "fas fa-exclamation warning");
        this.StandbyStop();
    }
    private _onRowClick(row: StaticTable.StaticTableRow<Types.Instrument>) {
        let entity = row.rowGroup.entity;
        this.openInstrumentEditor(entity.ID, entity.description, entity.allowedToEdit, entity);
    }

    private _onClickEditButton(rowGroup: StaticTable.StaticTableRowGroup<Types.Instrument>) {
        let entity = rowGroup.entity;
        this.openInstrumentEditor(entity.ID, entity.description, entity.allowedToEdit, entity);
    }

    private _onClick_editAddNewInstrument() {

        this.openInstrumentEditor();
    }

    private openInstrumentEditor(entityId?: string, description: string = "", allowedToEdit: boolean = true, entity?: Types.Instrument) {
        let form = new InternalInstrumentsEditor();
        let newLabel = this.translate("General_CreateNew") + " - " + this.translate("General_Label_InternalInstruments");
        let isNew: boolean;


        if (entity) {
            //form.loadEntity(entityId);
            form.setData(entity)
            if (!(entity.ref_owner.ID === this.userID)) form.setReadonly(true);
            isNew = false;
        } else {
            let newInstrument: Types.Instrument = {
                allowedToEdit: true,
                Classname: "",
                description: description,
                ID: "",
                ref_owner: this.user,
                ref_instruments_categorie: null,
                ref_user: null,
                userHistory: [],
                materials: []
            }
            form.setData(newInstrument);
            form.updateHeading(newLabel);
            form.setStartupState("ready");
            isNew = true;
        }

        form.setReadOnlyForMusicianProfile();

        let dlg = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;

        dlg.show(form,
            description,
            null,
            null,
            "okcancel",
            lang.hitch(this, this._onDlgCallback, dlg, form, isNew),
            { keepOpen: true })
    }

    private _onDlgCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof InternalInstrumentsEditor>>, isNew: boolean, result: number): void {
        if (result === 1) {
            let data: Types.Instrument = form.getCurrentData();
            if (isNew) {
                this.instrumentStore.addEntry(data);
            } else {
                this.instrumentStore.changeEntry(data, true);
            }
        }
        dlg.close();
    }

    private removeDeleteButtons(): void {
        let count = this.instrumentsTable.getRowCount();


        for (let i = 0; i < count; i++) {
            let rowGroup: StaticTable.StaticTableRowGroup<Types.Instrument> = this.instrumentsTable.getRowGroup(i);
            if (!(rowGroup.entity.ref_owner.ID === this.userID)) {

                this.instrumentsTable.enableActionButton("delete", rowGroup.entity, false, false);
            //    let actions = rowGroup.actions;
            //    let filteredActions = actions.filter((action) => action.name === "delete");
            //    let deleteAction;;
            //    if (filteredActions) deleteAction = filteredActions[0];

            //    if (deleteAction) this.hideNode(deleteAction.node, true);
            }
        }
    }

    postCreate(): void {
        this.RequestManager.handleAs = "jsonWithDate";
        super.postCreate.apply(this, arguments as any);

        this.instrumentStore = new EntityStore();
        this.instrumentStore.on("change", lang.hitch(this, this._onStoreChange, this._hasData(), this.instrumentStore.getDiffData()));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MusicianProfileForm);